// extracted by mini-css-extract-plugin
export var breadcrumb = "_1d-0";
export var breadcrumbArrow = "_1d-1";